<script>
    import Box from "../components/Box.svelte";
    import MatrixText from "../components/MatrixText.svelte";
    import config from './../config'
</script>

<svelte:head>
	<title>Damien ROCH | Contact Me</title>
</svelte:head>

<Box>
    <h1>
        <i class="fa-solid fa-user-astronaut" /> Send me a
        <strong><MatrixText value="Message" /></strong>
    </h1>

    <div class="columns">
        <div class="column ">
            <p class="mb-4">
                Just Send me <a href="mailto:{config.email}" class="link">an email</a> or contact me by <a href="{config.linkedinUrl}" class="link" rel="nofollow noopener"
                target="_blank">Linkedin</a>!
            </p>
        </div>

        <div class="column is-one-third has-text-centered">
        </div>
    </div>
</Box>
